<template>

    <tr :class="{ 'row-locked': rowDisabled }">
        <td class="matrix-w-530">
            <div class="matrix-dynamic__left-cell">
                <input
                    type="text"
                    :value="row.name"
                    class="form-control matrix-dynamic__input"
                    :tabindex="questionIndex"
                    :disabled="rowDisabled"
                    :readonly="readOnly"
                    @change.stop="changeLabelValue"
                    :placeholder="textPlaceholder"
                    maxlength="255"
                    :aria-label="$parent.headerTitle"
                >
            </div>
        </td>
        <td v-for="(column, index) of columns" :key="index"  class="matrix-w-220" :class="{ 'col-locked': isColumnDisabled(column.value) }">
            <input
                type="checkbox"
                class="checkbox-input"
                :name="uukey + '-' + row"
                :value="column.value"
                :checked="isChecked(column.value)"
                :disabled="rowDisabled || readOnly || isColumnDisabled(column.value)"
                @change.stop="changeColumnValue"
                :tabindex="questionIndex"
                maxlength="255"
                :aria-label="column.label"
            >
        </td>
        <td class="matrix-w-20">
            <button v-if="!readOnly" type="button" class="btn btn-link" :disabled="rowDisabled" :tabindex="questionIndex" @click.prevent.stop="removeRow" data-toggle="tooltip" :title="deleteButtonTitle"><span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span></button>
            <a v-if="readOnly" name="remove-row" class="btn btn-link" disabled><span class="glyphicon glyphicon-minus-sign" aria-hidden="true"></span></a>
        </td>
    </tr>

</template>


<script>
import { isObject, isNil, has } from 'lodash';
import { matrixRowMixin } from './mixins/matrix-row-mixin';
import { matrixColumnsMixin } from './mixins/matrix-columns-mixin';

export default {
    name: 'matrix-2d-inclusive-dynamic-row',

    mixins:[
        matrixRowMixin,
        matrixColumnsMixin,
    ],

    props:{
        row: [String, Object],
        textPlaceholder: String,
        deleteButtonTitle: String,
    },

    methods: {
        changeColumnValue($event)
        {
            const $target = $($event.target);
            this.$parent.changeColumnValue($event.target.value, $target.is(':checked'), this.row.id);
        },

        changeLabelValue($event)
        {
            this.$parent.changeColumnLabel($event.target.value, this.row.id);
        },

        removeRow($event)
        {
            this.$parent.removeRow(this.row.id);
        },

        isChecked(col)
        {
            if (this.isColumnDisabled(col))
            {
                return false;
            }
            if (has(this.row, col))
            {
                return this.row[col];
            }
            return false;
        },

    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-2d-inclusive-dynamic-rows-row.vue